import React, { useState, useEffect } from 'react';
import { C, LOGO_WIT, LETTERS_CSS, KOPLETTER, TEKSTLETTER, SMAL, Stippenraster } from './Login';

// De startpagina na het inloggen, alleen voor de rol beheerder. Toont de
// modules die op dezelfde inlog draaien. Elke andere gebruiker komt hier niet
// en gaat na het inloggen direct naar LaadAtlas.
//
// Dezelfde opbouw als het inlogscherm: petrol vlak links met logo, slogan en
// stippenraster, wit vlak rechts met de modules.

// Een module zonder doel heeft nog geen scherm: de tegel staat grijs en heeft
// geen knop.
const MODULES = [
  { id: 'laadatlas', titel: 'LaadAtlas',
    tekst: 'Strategisch laadplan per gemeente: behoefte, locaties, netcapaciteit en export.', open: true },
  { id: 'engine', titel: 'Intelligence Engine Laadplan',
    tekst: 'Toetst Laadplan aan Beleid.', open: false },
  { id: 'handhaving', titel: 'Monitoring Module Handhaving',
    tekst: 'Patronen bij gebruik laadpunten voor gerichte controles.', open: true },
  { id: 'cms', titel: 'CMS LaadAtlas',
    tekst: 'Beheeromgeving: gemeenten, gebruikers, toegang en gegevens.', open: true },
];

const RAND  = '#D9DFDF';
const GRIJS = '#EEF1F1';

function Tegel({ module, onOpen }) {
  const [boven, setBoven] = useState(false);
  const actief = module.open;
  return (
    <div
      onClick={actief ? () => onOpen(module.id) : undefined}
      onMouseEnter={() => setBoven(true)}
      onMouseLeave={() => setBoven(false)}
      aria-disabled={actief ? undefined : 'true'}
      style={{
        display: 'flex', flexDirection: 'column', gap: 10, boxSizing: 'border-box',
        minHeight: 168, padding: '22px 22px 18px', borderRadius: 10,
        border: `1px solid ${actief && boven ? C.teal : RAND}`,
        background: actief ? C.wit : GRIJS,
        boxShadow: actief && boven ? '0 6px 18px rgba(20,63,74,0.10)' : 'none',
        cursor: actief ? 'pointer' : 'default',
        transition: 'border-color 0.15s, box-shadow 0.15s',
      }}
    >
      <div style={{ fontFamily: KOPLETTER, fontSize: 18, fontWeight: 600,
                    color: actief ? C.petrol : C.grijs }}>
        {module.titel}
      </div>
      <div style={{ fontFamily: TEKSTLETTER, fontSize: 16, lineHeight: 1.5, color: C.grijs, maxWidth: '46ch' }}>
        {module.tekst}
      </div>
      {actief && (
        <div style={{ marginTop: 'auto', paddingTop: 6 }}>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onOpen(module.id); }}
            style={{
              background: boven ? C.teal : C.petrol, color: C.wit, border: 'none', borderRadius: 6,
              padding: '9px 20px', fontFamily: KOPLETTER, fontSize: 14, fontWeight: 600,
              cursor: 'pointer', transition: 'background 0.15s',
            }}
          >
            Openen
          </button>
        </div>
      )}
    </div>
  );
}

export default function Startpagina({ onOpen, onUitloggen }) {
  const [breedte, setBreedte] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1440);
  useEffect(() => {
    const bij = () => setBreedte(window.innerWidth);
    window.addEventListener('resize', bij);
    return () => window.removeEventListener('resize', bij);
  }, []);
  const smal = breedte < SMAL;

  const uitlogKnop = (
    <button
      type="button"
      onClick={onUitloggen}
      style={{
        background: 'none', border: '1px solid rgba(255,255,255,0.5)', color: C.wit,
        borderRadius: 6, padding: '6px 12px', fontFamily: TEKSTLETTER, fontSize: 14, cursor: 'pointer',
      }}
    >
      Uitloggen
    </button>
  );

  const gebruikerRegel = (
    <div style={{
      borderTop: '1px solid rgba(255,255,255,0.18)', paddingTop: 16,
      display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12,
      fontFamily: TEKSTLETTER, fontSize: 14, color: C.wit,
    }}>
      <span>Ingelogd als beheerder</span>
      {uitlogKnop}
    </div>
  );

  const slogan = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ fontFamily: KOPLETTER, fontSize: smal ? 20 : 26, fontWeight: 600, lineHeight: 1.25, color: C.wit }}>
        Datagedreven laadinfrastructuur<br />voor gemeenten
      </div>
      <div>
        <span style={{
          display: 'inline-block', fontFamily: KOPLETTER, fontSize: 13, fontWeight: 600,
          color: C.goud, border: `1px solid ${C.goud}`, borderRadius: 4, padding: '3px 10px',
        }}>
          2026
        </span>
      </div>
    </div>
  );

  const werkvlak = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 28, width: '100%', maxWidth: 880 }}>
      <div>
        <h1 style={{ margin: 0, fontFamily: KOPLETTER, fontSize: smal ? 26 : 30, fontWeight: 600,
                     color: C.petrol, lineHeight: 1.2 }}>
          Modules
        </h1>
      </div>
      <div style={{ display: 'grid', gap: 18,
                    gridTemplateColumns: smal ? '1fr' : 'repeat(2, minmax(0, 1fr))' }}>
        {MODULES.map(m => <Tegel key={m.id} module={m} onOpen={onOpen} />)}
      </div>
    </div>
  );

  const voetregel = (
    <div style={{ fontSize: 13, color: C.grijs, fontFamily: TEKSTLETTER }}>
      All rights reserved by Longhill BV
    </div>
  );

  // ── Smal scherm: petrol band met logo, daaronder de modules ──────────
  if (smal) {
    return (
      <div style={{ minHeight: '100vh', background: C.wit, display: 'flex', flexDirection: 'column' }}>
        <style>{LETTERS_CSS}</style>
        <div style={{ background: C.petrol, padding: '24px', display: 'flex', flexDirection: 'column', gap: 20 }}>
          <img src={LOGO_WIT} alt="LaadAtlas" style={{ width: 200, height: 'auto', display: 'block' }} />
          {gebruikerRegel}
        </div>
        <div style={{ flex: 1, padding: '28px 24px 24px', display: 'flex', flexDirection: 'column',
                      justifyContent: 'space-between', gap: 32 }}>
          {werkvlak}
          {voetregel}
        </div>
      </div>
    );
  }

  // ── Breed scherm: petrol vlak links, modules rechts ──────────────────
  return (
    <div style={{ minHeight: '100vh', display: 'flex', background: C.wit }}>
      <style>{LETTERS_CSS}</style>
      <div style={{
        width: 520, flexShrink: 0, boxSizing: 'border-box', minHeight: '100vh',
        background: C.petrol, padding: '56px 56px 32px',
        display: 'flex', flexDirection: 'column', gap: 36,
      }}>
        <img src={LOGO_WIT} alt="LaadAtlas" style={{ width: 240, height: 'auto', display: 'block' }} />
        {slogan}
        <div style={{ marginTop: 'auto' }}><Stippenraster /></div>
        {gebruikerRegel}
      </div>
      <div style={{
        flex: 1, minWidth: 0, minHeight: '100vh', boxSizing: 'border-box', padding: '56px 48px 32px',
        display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: 32,
      }}>
        {werkvlak}
        {voetregel}
      </div>
    </div>
  );
}
